import { render } from "./UploadFileModal.vue?vue&type=template&id=34604d4a"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__